<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      支付日志
      <small>
        /&nbsp;
        <router-link to="/OrderListsummary" class="TitleStyle">支付列表</router-link>&nbsp;
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">支付详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">基本信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">订单编号：</span>
                        <span class="TCodeContent">{{OrderList.orderNo}}</span>
                      </li>
                      <!-- recom  渠道号 -->
                      <li class="TableContent">
                        <span class="TCode">渠道号：</span>
                        <span class="TCodeContent">{{OrderList.recom}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">服务商名称：</span>
                        <span class="TCodeContent">{{OrderList.recomName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">订购人：</span>
                        <span class="TCodeContent">{{OrderList.trueName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">支付流水号：</span>
                        <span class="TCodeContent">{{OrderList.payVoucher}}</span>
                      </li>
                      <!--  payVoucher -->
                      <li class="TableContent">
                        <span class="TCode">身份证号：</span>
                        <span class="TCodeContent">{{OrderList.idCard}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">门店名称：</span>
                        <span class="TCodeContent">{{OrderList.shopName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">支付时间：</span>
                        <span class="TCodeContent">{{OrderList.payTime}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">银行卡号：</span>
                        <span class="TCodeContent">{{OrderList.bankCard}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行名称：</span>
                        <span class="TCodeContent">{{OrderList.bankName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">订单状态：</span>
                        <span class="TCodeContent">{{OrderList.status}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <!-- 订单商品信息 -->
                  <div class="GTitle">
                    <span class="TInfo">订单商品信息</span>
                  </div>
                  <div class="GContent">
                    <el-table :data="tableData" border style="width: 100%">
                      <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
                      <el-table-column prop="goodsId" label="商品ID" align="center"></el-table-column>
                      <el-table-column prop="goodsName" label="商品名称" align="center"   show-overflow-tooltip></el-table-column>
                      <el-table-column prop="packageRates" label="包装率" width="180" align="center"></el-table-column>
                      <el-table-column
                        prop="packageCount"
                        label="包装率商品件数"
                        width="180"
                        show-overflow-tooltip
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        prop="packagePrice"
                        label="包装率商品价格"
                        width="180"
                        align="center"
                      ></el-table-column>
                      <el-table-column prop="totalCount" label="商品总件数" width="180" align="center"></el-table-column>
                    </el-table>
                  </div>
                  <div style="height:46px;padding-top:16px;">
                    <a
                      class="btn btn-primary m-r-5"
                      style="float:right;cursor:pointer;color:#fff !important"
                      @click="Goback"
                    >返&nbsp;&nbsp;回</a>
                    <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
export default {
  name: "OrderDetailsummary",
  data() {
    return {
      // 表格数据
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      //  基本信息
      OrderList: [],
      //------------- 
      activities: [],
      searchContent: {},
    };
  },
  mounted: function() {
    this.initdata();
    this.getdata();
  },
  methods: {
    getdata() {
      this.OrderList = JSON.parse(localStorage.getItem("paylist")).row;
      if (this.OrderList.status == 1) this.OrderList.status = "未处理";
      if (this.OrderList.status == 0) this.OrderList.status = "已处理";
    },
    Goback() {
      this.$router.push({
        name: "OrderListsummary"
      });
    },
    // 二级联动 的  处理函数
    initdata() {
      let that = this;
      if (localStorage.getItem("paylist")) {
        let paylist = localStorage.getItem("paylist");
        this.pageNo = JSON.parse(paylist).pageNo;
        this.pageSize = JSON.parse(paylist).pageSize;
        // 用户输入   信息
        this.searchContent = JSON.parse(paylist).searchContent;
      }
      const initoptions = {
        url: "/distribution/PayExceptionOrderController/detailsExceptionInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          // 订单编号      ---- 必填项
          orderNO: JSON.parse(localStorage.getItem("paylist")).row.orderNo
        })
      };
      axios(initoptions)
        .then(function(response) {
          if (response.data.code == 200) {
            // 数据表格
            if (response.data.data.records.length > 0) {
              for (var i in response.data.data.records) {
                // 处理 返回的  数据     强行添加   goodsName   属性
                response.data.data.records[i].goodsName =
                  response.data.data.goodsName;
              }
              // 将表格数据   放进 tableData数组中 
              that.tableData = response.data.data.records;
            }
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width: 1360px) and (max-width: 1680px) {
  /*二栏布局*/
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width: 1680px) and (max-width: 2000px) {
  /*二栏布局*/
  .TableContent {
    width: calc(100% / 3);
  }
}
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 150px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 150px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.tableAll,
.tableOne,
.tableSku {
  font-size: 14px;
  margin-bottom: 0;
}
.tableAll > tbody > tr > td {
  border: none;
  width: 25%;
  padding: 5px 15px;
}
.tableAll > tbody > tr {
  text-align: left;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
}
.tableOne {
  border: 1px #e5e5e5 solid;
}
.tbheader {
  background: #f4f4f4;
  text-align: left;
}
.tbone {
  border: 1px #e5e5e5 solid;
}
.trbottom > td {
  border-bottom: none;
}
.tdprice {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderDetailsummary.vue